import { __spreadArrays } from "tslib";
import { get, keyBy, map, find, includes } from 'lodash';
import { createSelector } from 'reselect';
export var getCategories = function (state) { return state.categories; };
export var getCategoryIds = createSelector([getCategories], function (categories) { return map(categories, '_id'); });
export var getCategoriesMap = createSelector([getCategories], function (categories) { return keyBy(categories, '_id'); });
export var getCategoryCount = function (state) { return getCategories(state).length; };
var getCategorySlug = function (state, categorySlug) { return categorySlug; };
export var getFistCategoryId = function (state) { return get(getCategories(state), '[0]._id'); };
export var getCategory = function (state, id) { return getCategoriesMap(state)[id]; };
export var getCategoryBySlug = createSelector([getCategories, getCategorySlug], function (categories, categorySlug) {
    return find(categories, function (category) { return includes(category.slugs, categorySlug) || includes(category.slugs, categorySlug + "/"); });
});
export var getHighestRank = createSelector([getCategories], function (categories) {
    return Math.max.apply(Math, __spreadArrays([-1], map(categories, function (category) { return category.rank; })));
});
